import React from 'react';
import CareerHeroSection from '../components/CareerHeroSection';
import './Career.css';

function Career() {
  return (
    <div>
      <CareerHeroSection />
      <section className="career-content">
        {/* Hot Jobs Section */}
        <h2>Hot Jobs</h2>
        <p>We are always looking for talented individuals to join our team. Here are some of the exciting roles we are hiring for:</p>
        <ul>
          <li>Data Analysts</li>
          <li>Data Scientists</li>
          <li>AI Engineers</li>
          <li>Software Engineers</li>
          <li>DevOps Engineers</li>
          <li>Cloud Architects</li>
          <li>Full-Stack Developers</li>
        </ul>

        {/* Benefits Section */}
        <h2>Why Work With Us?</h2>
        <p>At NorthHawks, we believe in creating an environment where our team members can thrive both professionally and personally. Here’s why you’ll love working with us:</p>
        <ul>
          <li>Work-life balance to ensure you have time for what matters most.</li>
          <li>Competitive salary packages that recognize your skills and contributions.</li>
          <li>Opportunities to work on cutting-edge technologies and future-oriented projects.</li>
          <li>Collaborative and inclusive work culture where your ideas matter.</li>
          <li>Continuous learning and development programs to help you grow.</li>
          <li>Flexible work arrangements, including remote work options.</li>
          <li>Health and wellness benefits to support your well-being.</li>
        </ul>

        {/* Technologies Section */}
        <h2>Our Tech Stack</h2>
        <p>We are passionate about working with the latest and most innovative technologies. Here’s a glimpse of the tools and technologies we love:</p>
        <ul>
          <li>Programming Languages: Python, Java, Kotlin, JavaScript</li>
          <li>Frontend Frameworks: React, Angular</li>
          <li>Backend Frameworks: Node.js, Spring Boot</li>
          <li>Cloud Platforms: AWS, Azure, Google Cloud</li>
          <li>DevOps Tools: Jenkins, Docker, Kubernetes, CI/CD Pipelines</li>
          <li>Data Tools: Kafka, ElasticSearch, Dynatrace</li>
          <li>Monitoring & Observability: Prometheus, Grafana</li>
        </ul>

        {/* Call-to-Action Section */}
        <h2>Apply Now</h2>
        <p>
          We’d love to hear from you! If you’re passionate about technology and excited to work on innovative projects, send us your resume at{' '}
          <a href="mailto:career@northhawks.ca">career@northhawks.ca</a>. 
        </p>
        <p>
          Don’t worry if you don’t see a role that matches your skills perfectly—reach out anyway! We’re always on the lookout for talented individuals who can bring fresh ideas and energy to our team.
        </p>
      </section>
    </div>
  );
}

export default Career;